/**
 * Run Keystone required-option validation before SureBright can open
 * its warranty popup or add the product to cart via "No, Thanks".
 *
 * This file is loaded synchronously in <head> so its capture listeners
 * and fetch wrapper register before the SureBright SDK.
 */
(function () {
  if (window.__keystoneAtcValidationInstalled) return;
  window.__keystoneAtcValidationInstalled = true;

  function optionsRoot() {
    return document.getElementById('key_options_block') || document.querySelector('.key_options_form');
  }

  function isHiddenByCondition(el) {
    return Boolean(el && el.closest('.key_option_condition_hidden'));
  }

  function isWrapperVisible(wrapper) {
    if (!wrapper || isHiddenByCondition(wrapper)) return false;
    if (typeof window.getComputedStyle !== 'function') return true;
    var style = window.getComputedStyle(wrapper);
    if (style.display === 'none' || style.visibility === 'hidden') return false;
    return wrapper.getClientRects().length > 0;
  }

  function isRequiredWrapper(wrapper) {
    if (wrapper.querySelector('[required], [aria-required="true"]')) return true;

    var srOnly = wrapper.querySelector('.key_option_title .sr-only, .key_option_title [class*="sr-only"]');
    if (srOnly && /required/i.test(srOnly.textContent || '')) return true;

    var title = wrapper.querySelector('.key_option_title');
    return Boolean(title && /\*/.test(title.textContent || ''));
  }

  function isOptionFilled(wrapper) {
    var radios = wrapper.querySelectorAll('input[type="radio"]');
    if (radios.length) {
      return Array.prototype.some.call(radios, function (input) {
        return input.checked;
      });
    }

    var checkboxes = wrapper.querySelectorAll('input[type="checkbox"]');
    if (checkboxes.length) {
      return Array.prototype.some.call(checkboxes, function (input) {
        return input.checked;
      });
    }

    var select = wrapper.querySelector('select');
    if (select) return select.value.trim() !== '';

    var files = wrapper.querySelectorAll('input[type="file"]');
    if (files.length) {
      return Array.prototype.some.call(files, function (input) {
        return input.files && input.files.length > 0;
      });
    }

    var fields = wrapper.querySelectorAll(
      'input:not([type="hidden"]):not([type="radio"]):not([type="checkbox"]):not([type="file"]):not([type="button"]):not([type="submit"]), textarea'
    );
    if (fields.length) {
      return Array.prototype.some.call(fields, function (input) {
        return (input.value || '').trim() !== '';
      });
    }

    return Boolean(
      wrapper.querySelector(
        '.key_swatch_selected, .key_button_selected, .key_selection_item_selected'
      )
    );
  }

  function requiredOptionWrappers() {
    var root = optionsRoot();
    if (!root) return [];

    var wrappers = Array.prototype.filter.call(root.querySelectorAll('.key_option_wrapper'), function (wrapper) {
      return isWrapperVisible(wrapper) && isRequiredWrapper(wrapper);
    });

    if (wrappers.length) return wrappers;

    return Array.prototype.filter.call(root.querySelectorAll('.key_option'), function (option) {
      return isWrapperVisible(option) && isRequiredWrapper(option);
    });
  }

  function getInvalidRequiredWrappers() {
    return requiredOptionWrappers().filter(function (wrapper) {
      return !isOptionFilled(wrapper);
    });
  }

  function requiredOptionsAreValid() {
    if (!optionsRoot() || !document.querySelector('.key_option, .key_options_form')) {
      return true;
    }
    return getInvalidRequiredWrappers().length === 0;
  }

  function markOptionError(wrapper) {
    var option = wrapper.querySelector('.key_option') || wrapper;
    option.classList.add('validation-error');
    wrapper.querySelectorAll('[data-keystone-atc-error]').forEach(function (el) {
      el.remove();
    });
  }

  function clearOptionError(wrapper) {
    var option = wrapper.querySelector('.key_option') || wrapper;
    option.classList.remove('validation-error');
    wrapper.querySelectorAll('[data-keystone-atc-error]').forEach(function (el) {
      el.remove();
    });
  }

  function scrollToFirstError(wrapper) {
    if (!wrapper) return;
    var option = wrapper.querySelector('.key_option') || wrapper;
    option.scrollIntoView({ behavior: 'smooth', block: 'center' });

    var focusable = option.querySelector(
      "input:not([type='hidden']):not([disabled]), select:not([disabled]), textarea:not([disabled]), [role='radio'], [role='button'], [tabindex]:not([tabindex='-1'])"
    );
    if (focusable && typeof focusable.focus === 'function') {
      try {
        focusable.focus({ preventScroll: true });
      } catch (err) {
        focusable.focus();
      }
    }
  }

  function closeSureBrightPopup() {
    document.querySelectorAll('#lm-modal, .productRegistrationPopup, .sb-popup__wrapper, .sb-pp-modal-overlay, .sb-popup').forEach(function (el) {
      el.style.display = 'none';
    });
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
    window.isAddToCartEventQueued = false;
    window.calledBySB = false;
  }

  function triggerKeystoneValidation(form) {
    if (!form) {
      form = document.querySelector('[data-product-form], form[action*="/cart/add"]');
    }
    if (!form) return;
    form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
  }

  function showRequiredOptionErrors() {
    var invalid = getInvalidRequiredWrappers();
    if (!invalid.length) return false;

    requiredOptionWrappers().forEach(function (wrapper) {
      if (isOptionFilled(wrapper)) {
        clearOptionError(wrapper);
      } else {
        markOptionError(wrapper);
      }
    });

    closeSureBrightPopup();
    scrollToFirstError(invalid[0]);
    triggerKeystoneValidation(invalid[0].closest('form'));
    return true;
  }

  function isAddToCartTarget(target) {
    if (!target || typeof target.closest !== 'function') return false;
    if (target.closest('#lm-modal, .productRegistrationPopup, .sb-popup, .sb-pp-modal-overlay')) {
      return false;
    }
    return Boolean(
      target.closest('[data-product-atc]') ||
        target.closest('.product-form--atc-button') ||
        target.closest('button[name="add"]') ||
        target.closest('input[name="add"]') ||
        target.closest('[data-add-btn]')
    );
  }

  function isSureBrightProceedTarget(target) {
    if (!target || typeof target.closest !== 'function') return false;
    return Boolean(
      target.closest('#need-no-protection') ||
        target.closest('.need-no-protection') ||
        target.closest('#modalAddToCartButton') ||
        target.closest('.add-protection-button') ||
        target.closest('.sbModalClose')
    );
  }

  function blockEvent(event) {
    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    }
  }

  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      if (!isAddToCartTarget(target) && !isSureBrightProceedTarget(target)) return;
      if (requiredOptionsAreValid()) return;

      blockEvent(event);
      showRequiredOptionErrors();
    },
    true
  );

  document.addEventListener(
    'change',
    function (event) {
      var wrapper = event.target && event.target.closest && event.target.closest('.key_option_wrapper');
      if (wrapper && isOptionFilled(wrapper)) clearOptionError(wrapper);
    },
    true
  );

  document.addEventListener(
    'click',
    function (event) {
      var wrapper = event.target && event.target.closest && event.target.closest('.key_option_wrapper');
      if (!wrapper) return;
      setTimeout(function () {
        if (isOptionFilled(wrapper)) clearOptionError(wrapper);
      }, 0);
    },
    true
  );

  function isCartAddRequest(url, method) {
    if (!url) return false;
    var resolvedMethod = (method || 'GET').toString().toUpperCase();
    if (resolvedMethod !== 'POST' && resolvedMethod !== 'PUT') return false;
    return /\/cart\/add/i.test(String(url));
  }

  var originalFetch = window.fetch;
  if (typeof originalFetch === 'function') {
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : input && (input.url || input.href || String(input));
      var method = (init && init.method) || (input && input.method) || 'GET';

      if (isCartAddRequest(url, method) && !requiredOptionsAreValid()) {
        showRequiredOptionErrors();
        return Promise.reject(new DOMException('Required product options are missing', 'AbortError'));
      }

      return originalFetch.apply(this, arguments);
    };
  }

  var originalXhrOpen = XMLHttpRequest.prototype.open;
  var originalXhrSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (method, url) {
    this.__keystoneAtcMethod = method;
    this.__keystoneAtcUrl = url;
    return originalXhrOpen.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function () {
    if (isCartAddRequest(this.__keystoneAtcUrl, this.__keystoneAtcMethod) && !requiredOptionsAreValid()) {
      showRequiredOptionErrors();
      this.abort();
      return;
    }
    return originalXhrSend.apply(this, arguments);
  };
})();
